const remoteUtils = await import( 'AAPE_Sync/utilities' );

let init = function () {

	/* eslint-disable no-empty,no-undef,no-unsafe-finally,no-unused-vars */

	( function () {

		let isProdBootstrap = function () {

			let _pp = remoteUtils.getPublishPath();

			if ( _pp === 'prod' || _pp === 'beta' ) {

				return true;
			}
			else {

				return false;

			}

		}

		if ( isProdBootstrap && isProdBootstrap() === true ) {
			(function () {
                var merchantConfig = {
                    csp: false,
                };
                var sri = "sha256-eFvch9KBWQnD5jda2Uc8/Y2/L85f/jOmFd5XtL/krxY=";

                var siteId = "1ad356638475";
                function t(t, n) {
                    for (var e = t.split(""), r = 0; r < e.length; ++r)
                        e[r] = String.fromCharCode(e[r].charCodeAt(0) + n);
                    return e.join("");
                }
                function n(n) {
                    return t(n, -x).replace(/%SN%/g, siteId);
                }
                function e() {
                    var t = "no" + "op" + "fn",
                        n = "g" + "a",
                        e = "n" + "ame";
                    return window[n] && window[n][e] === t;
                }
                function r() {
                    return !(
                        !navigator.brave ||
                        "function" != typeof navigator.brave.isBrave
                    );
                }
                function o() {
                    return document.currentScript && document.currentScript.src;
                }
                function i(t) {
                    try {
                        if (
                            "number" == typeof t &&
                            window.location &&
                            window.location.pathname
                        ) {
                            for (
                                var n = window.location.pathname.split("/"),
                                    e = [],
                                    r = 0;
                                r <= Math.min(n.length - 1, Math.abs(t));
                                r++
                            )
                                e.push(n[r]);
                            return e.join("/") || "/";
                        }
                    } catch (t) {}
                    return "/";
                }
                function c(t) {
                    try {
                        (B.ex = t),
                            e() && -1 === B.ex.indexOf(j.uB) && (B.ex += j.uB),
                            r() &&
                                -1 === B.ex.indexOf(j.uBr) &&
                                (B.ex += j.uBr),
                            o() &&
                                -1 === B.ex.indexOf(j.nIL) &&
                                (B.ex += j.nIL),
                            window.ftr__snp_cwc || (B.ex += j.s),
                            M(B);
                    } catch (t) {}
                }
                function a(t, n) {
                    function e(o) {
                        try {
                            o.blockedURI === t &&
                                (n(), document.removeEventListener(r, e));
                        } catch (t) {
                            document.removeEventListener(r, e);
                        }
                    }
                    var r = "securitypolicyviolation";
                    document.addEventListener(r, e),
                        setTimeout(function () {
                            document.removeEventListener(r, e);
                        }, 2 * 60 * 1e3);
                }
                function u(t, n, e, r) {
                    var o = !1;
                    n && (t = t.replace("%I%", encodeURIComponent(n))),
                        (t = "https://" + t),
                        a(t, function () {
                            r(!0), (o = !0);
                        });
                    var i = document.createElement("script");
                    (i.onerror = function () {
                        if (!o)
                            try {
                                r(!1), (o = !0);
                            } catch (t) {}
                    }),
                        (i.onload = e),
                        (i.type = "text/javascript"),
                        (i.id = "ftr__script"),
                        (i.async = !0),
                        (i.src = t),
                        n && ((i.integrity = n), (i.crossOrigin = !0));
                    var c = document.getElementsByTagName("script")[0];
                    c.parentNode.insertBefore(i, c);
                }
                function f() {
                    J(j.uDF), setTimeout(m, q, j.uDF);
                }
                function d(t, n, e, r) {
                    var o = !1,
                        i = new XMLHttpRequest();
                    if (
                        (a("https:" + t, function () {
                            e(new Error("CSP Violation"), !0), (o = !0);
                        }),
                        "//" === t.slice(0, 2) && (t = "https:" + t),
                        "withCredentials" in i)
                    )
                        i.open("GET", t, !0);
                    else {
                        if ("undefined" == typeof XDomainRequest) return;
                        (i = new XDomainRequest()), i.open("GET", t);
                    }
                    Object.keys(r).forEach(function (t) {
                        i.setRequestHeader(t, r[t]);
                    }),
                        (i.onload = function () {
                            "function" == typeof n && n(i);
                        }),
                        (i.onerror = function (t) {
                            if ("function" == typeof e && !o)
                                try {
                                    e(t, !1), (o = !0);
                                } catch (t) {}
                        }),
                        (i.onprogress = function () {}),
                        (i.ontimeout = function () {
                            "function" == typeof e &&
                                e("tim" + "eo" + "ut", !1);
                        }),
                        setTimeout(function () {
                            i.send();
                        }, 0);
                }
                function s(t, siteId, n) {
                    function e(t) {
                        var n = t.toString(16);
                        return n.length % 2 ? "0" + n : n;
                    }
                    function r(t) {
                        if (t <= 0) return "";
                        for (
                            var n = "0123456789abcdef", e = "", r = 0;
                            r < t;
                            r++
                        )
                            e += n[Math.floor(Math.random() * n.length)];
                        return e;
                    }
                    function o(t) {
                        for (var n = "", r = 0; r < t.length; r++)
                            n += e(t.charCodeAt(r));
                        return n;
                    }
                    function i(t) {
                        for (var n = t.split(""), e = 0; e < n.length; ++e)
                            n[e] = String.fromCharCode(
                                255 ^ n[e].charCodeAt(0)
                            );
                        return n.join("");
                    }
                    n = n ? "1" : "0";
                    var c = [];
                    return (
                        c.push(t),
                        c.push(siteId),
                        c.push(n),
                        (function (t) {
                            var n = 40,
                                e = "";
                            return (
                                t.length < n / 2 &&
                                    (e = "," + r(n / 2 - t.length - 1)),
                                o(i(t + e))
                            );
                        })(c.join(","))
                    );
                }
                function w() {
                    function t() {
                        C && (J(j.dUAL), setTimeout(m, q, j.dUAL));
                    }
                    function n(t, n) {
                        c(n ? j.uAS + j.uF + j.cP : j.uAS + j.uF);
                    }
                    window.ftr__fdad(t, n);
                }
                function m(t) {
                    try {
                        var n;
                        switch (t) {
                            case j.uFP:
                                n = V;
                                break;
                            case j.uDF:
                                n = I;
                                break;
                            default:
                                n = C;
                        }
                        if (!n) return;
                        var e = function () {
                                try {
                                    K(), c(t + j.uS);
                                } catch (t) {}
                            },
                            r = function (n) {
                                try {
                                    K(),
                                        (B.td = 1 * new Date() - B.ts),
                                        c(n ? t + j.uF + j.cP : t + j.uF),
                                        t === j.uFP && f(),
                                        t === j.uDF && w();
                                } catch (t) {
                                    c(j.eUoe);
                                }
                            };
                        u(n, sri, e, r);
                    } catch (n) {
                        c(t + j.eTlu);
                    }
                }
                var h = "22ge:t7mj8unkn;1forxgiurqw1qhw2vwdwxv",
                    v = "fort",
                    l = "erTo",
                    p = "ken";
                window.ftr__config = { m: merchantConfig, s: "23", si: siteId };
                var g = !1,
                    _ = v + l + p,
                    y = 400 * 24 * 60,
                    T = 10,
                    k = {
                        write: function (t, n, e, r) {
                            void 0 === r && (r = !0);
                            var o = 0;
                            window.ftr__config &&
                                window.ftr__config.m &&
                                window.ftr__config.m.ckDepth &&
                                (o = window.ftr__config.m.ckDepth);
                            var c,
                                a,
                                u = i(o);
                            if (
                                (e
                                    ? ((c = new Date()),
                                      c.setTime(c.getTime() + 60 * e * 1e3),
                                      (a = "; expires=" + c.toGMTString()))
                                    : (a = ""),
                                !r)
                            )
                                return void (document.cookie =
                                    escape(t) +
                                    "=" +
                                    escape(n) +
                                    a +
                                    "; path=" +
                                    u);
                            for (
                                var f = 1,
                                    d = document.domain.split("."),
                                    s = T,
                                    w = !0;
                                w && d.length >= f && s > 0;

                            ) {
                                var m = d.slice(-f).join(".");
                                document.cookie =
                                    escape(t) +
                                    "=" +
                                    escape(n) +
                                    a +
                                    "; path=" +
                                    u +
                                    "; domain=" +
                                    m;
                                var h = k.read(t);
                                (null != h && h == n) ||
                                    ((m = "." + m),
                                    (document.cookie =
                                        escape(t) +
                                        "=" +
                                        escape(n) +
                                        a +
                                        "; path=" +
                                        u +
                                        "; domain=" +
                                        m)),
                                    (w =
                                        -1 ===
                                        document.cookie.indexOf(t + "=" + n)),
                                    f++,
                                    s--;
                            }
                        },
                        read: function (t) {
                            var n = null;
                            try {
                                for (
                                    var e = escape(t) + "=",
                                        r = document.cookie.split(";"),
                                        o = 32,
                                        i = 0;
                                    i < r.length;
                                    i++
                                ) {
                                    for (var c = r[i]; c.charCodeAt(0) === o; )
                                        c = c.substring(1, c.length);
                                    0 === c.indexOf(e) &&
                                        (n = unescape(
                                            c.substring(e.length, c.length)
                                        ));
                                }
                            } finally {
                                return n;
                            }
                        },
                    },
                    L = window.ftr__config.s;
                L += "ck";
                var S = function (t) {
                        var n = !1,
                            e = null,
                            r = function () {
                                try {
                                    if (!e || !n) return;
                                    e.remove && "function" == typeof e.remove
                                        ? e.remove()
                                        : document.head.removeChild(e),
                                        (n = !1);
                                } catch (t) {}
                            };
                        document.head &&
                            (!(function () {
                                (e = document.createElement("link")),
                                    e.setAttribute(
                                        "rel",
                                        "pre" + "con" + "nect"
                                    ),
                                    e.setAttribute(
                                        "cros" + "sori" + "gin",
                                        "anonymous"
                                    ),
                                    (e.onload = r),
                                    (e.onerror = r),
                                    e.setAttribute("href", t),
                                    document.head.appendChild(e),
                                    (n = !0);
                            })(),
                            setTimeout(r, 3e3));
                    },
                    x = 3,
                    A = n(h || "22ge:t7mj8unkn;1forxgiurqw1qhw2vwdwxv"),
                    U = t("[0Uhtxhvw0LG", -x),
                    F = t("[0Fruuhodwlrq0LG", -x),
                    b = t("Li0Qrqh0Pdwfk", -x),
                    C,
                    D = "fgq71iruwhu1frp",
                    I = n("(VQ(1" + D + "2vq2(VQ(2(L(2vfulsw1mv"),
                    E = n("(VQ(1" + D + "2vqV2(VQ(2(L(2vfulsw1mv"),
                    V;
                window.ftr__config &&
                    window.ftr__config.m &&
                    window.ftr__config.m.fpi &&
                    (V = window.ftr__config.m.fpi + n("2vq2(VQ(2vfulsw1mv"));
                var q = 10;
                window.ftr__startScriptLoad = 1 * new Date();
                var R = function (t) {
                        var n = "ft" + "r:tok" + "enR" + "eady";
                        window.ftr__tt && clearTimeout(window.ftr__tt),
                            (window.ftr__tt = setTimeout(function () {
                                try {
                                    delete window.ftr__tt, (t += "_tt");
                                    var e = document.createEvent("Event");
                                    e.initEvent(n, !1, !1),
                                        (e.detail = t),
                                        document.dispatchEvent(e);
                                } catch (t) {}
                            }, 1e3));
                    },
                    M = function (t) {
                        var n = function (t) {
                                return t || "";
                            },
                            e =
                                n(t.id) +
                                "_" +
                                n(t.ts) +
                                "_" +
                                n(t.td) +
                                "_" +
                                n(t.ex) +
                                "_" +
                                n(L),
                            r = y;
                        !isNaN(window.ftr__config.m.ckTTL) &&
                            window.ftr__config.m.ckTTL &&
                            (r = window.ftr__config.m.ckTTL),
                            k.write(_, e, r, !0),
                            R(e),
                            (window.ftr__gt = e);
                    },
                    O = function () {
                        var t = k.read(_) || "",
                            n = t.split("_"),
                            e = function (t) {
                                return n[t] || void 0;
                            };
                        return {
                            id: e(0),
                            ts: e(1),
                            td: e(2),
                            ex: e(3),
                            vr: e(4),
                        };
                    },
                    P = (function () {
                        for (var t = {}, n = "fgu", e = [], r = 0; r < 256; r++)
                            e[r] = (r < 16 ? "0" : "") + r.toString(16);
                        var o = function (t, n, r, o, i) {
                                var c = i ? "-" : "";
                                return (
                                    e[255 & t] +
                                    e[(t >> 8) & 255] +
                                    e[(t >> 16) & 255] +
                                    e[(t >> 24) & 255] +
                                    c +
                                    e[255 & n] +
                                    e[(n >> 8) & 255] +
                                    c +
                                    e[((n >> 16) & 15) | 64] +
                                    e[(n >> 24) & 255] +
                                    c +
                                    e[(63 & r) | 128] +
                                    e[(r >> 8) & 255] +
                                    c +
                                    e[(r >> 16) & 255] +
                                    e[(r >> 24) & 255] +
                                    e[255 & o] +
                                    e[(o >> 8) & 255] +
                                    e[(o >> 16) & 255] +
                                    e[(o >> 24) & 255]
                                );
                            },
                            i = function () {
                                if (
                                    window.Uint32Array &&
                                    window.crypto &&
                                    window.crypto.getRandomValues
                                ) {
                                    var t = new window.Uint32Array(4);
                                    return (
                                        window.crypto.getRandomValues(t),
                                        {
                                            d0: t[0],
                                            d1: t[1],
                                            d2: t[2],
                                            d3: t[3],
                                        }
                                    );
                                }
                                return {
                                    d0: (4294967296 * Math.random()) >>> 0,
                                    d1: (4294967296 * Math.random()) >>> 0,
                                    d2: (4294967296 * Math.random()) >>> 0,
                                    d3: (4294967296 * Math.random()) >>> 0,
                                };
                            },
                            c = function () {
                                var t = "",
                                    n = function (t, n) {
                                        for (var e = "", r = t; r > 0; --r)
                                            e += n.charAt(
                                                (1e3 * Math.random()) % n.length
                                            );
                                        return e;
                                    };
                                return (
                                    (t += n(2, "0123456789")),
                                    (t += n(1, "123456789")),
                                    (t += n(8, "0123456789"))
                                );
                            };
                        return (
                            (t.safeGenerateNoDash = function () {
                                try {
                                    var t = i();
                                    return o(t.d0, t.d1, t.d2, t.d3, !1);
                                } catch (t) {
                                    try {
                                        return n + c();
                                    } catch (t) {}
                                }
                            }),
                            (t.isValidNumericalToken = function (t) {
                                return (
                                    t &&
                                    t.toString().length <= 11 &&
                                    t.length >= 9 &&
                                    parseInt(t, 10).toString().length <= 11 &&
                                    parseInt(t, 10).toString().length >= 9
                                );
                            }),
                            (t.isValidUUIDToken = function (t) {
                                return (
                                    t &&
                                    32 === t.toString().length &&
                                    /^[a-z0-9]+$/.test(t)
                                );
                            }),
                            (t.isValidFGUToken = function (t) {
                                return 0 == t.indexOf(n) && t.length >= 12;
                            }),
                            t
                        );
                    })(),
                    j = {
                        uDF: "UDF",
                        dUAL: "dUAL",
                        uAS: "UAS",
                        uFP: "UFP",
                        mLd: "1",
                        eTlu: "2",
                        eUoe: "3",
                        uS: "4",
                        uF: "9",
                        tmos: ["T5", "T10", "T15", "T30", "T60"],
                        tmosSecs: [5, 10, 15, 30, 60],
                        bIR: "43",
                        uB: "u",
                        uBr: "b",
                        cP: "c",
                        nIL: "i",
                        s: "s",
                    };
                try {
                    var B = O();
                    try {
                        B.id &&
                        (P.isValidNumericalToken(B.id) ||
                            P.isValidUUIDToken(B.id) ||
                            P.isValidFGUToken(B.id))
                            ? (window.ftr__ncd = !1)
                            : ((B.id = P.safeGenerateNoDash()),
                              (window.ftr__ncd = !0)),
                            (B.ts = window.ftr__startScriptLoad),
                            M(B),
                            (window.ftr__snp_cwc = !!k.read(_)),
                            window.ftr__snp_cwc || (I = E);
                        for (
                            var G = "for" + "ter" + ".co" + "m",
                                N = "ht" + "tps://c" + "dn9." + G,
                                Q =
                                    "ht" +
                                    "tps://" +
                                    B.id +
                                    "-" +
                                    siteId +
                                    ".cd" +
                                    "n." +
                                    G,
                                H = "http" + "s://cd" + "n3." + G,
                                X = [N, Q, H],
                                z = 0;
                            z < X.length;
                            z++
                        )
                            S(X[z]);
                        var $ = new Array(j.tmosSecs.length),
                            J = function (t) {
                                for (var n = 0; n < j.tmosSecs.length; n++)
                                    $[n] = setTimeout(
                                        c,
                                        1e3 * j.tmosSecs[n],
                                        t + j.tmos[n]
                                    );
                            },
                            K = function () {
                                for (var t = 0; t < j.tmosSecs.length; t++)
                                    clearTimeout($[t]);
                            };
                        window.ftr__fdad = function (n, e) {
                            if (!g) {
                                g = !0;
                                var r = {};
                                (r[b] = s(
                                    window.ftr__config.s,
                                    siteId,
                                    window.ftr__config.m.csp
                                )),
                                    d(
                                        A,
                                        function (e) {
                                            try {
                                                var r = e
                                                    .getAllResponseHeaders()
                                                    .toLowerCase();
                                                if (
                                                    r.indexOf(
                                                        F.toLowerCase()
                                                    ) >= 0
                                                ) {
                                                    var o =
                                                        e.getResponseHeader(F);
                                                    window.ftr__altd2 = t(
                                                        atob(o),
                                                        -x - 1
                                                    );
                                                }
                                                if (
                                                    r.indexOf(U.toLowerCase()) <
                                                    0
                                                )
                                                    return;
                                                var i = e.getResponseHeader(U),
                                                    c = t(atob(i), -x - 1);
                                                if (c) {
                                                    var a = c.split(":");
                                                    if (a && 2 === a.length) {
                                                        for (
                                                            var u = a[0],
                                                                f = a[1],
                                                                d = "",
                                                                s = 0,
                                                                w = 0;
                                                            s < 20;
                                                            ++s
                                                        )
                                                            d +=
                                                                s % 3 > 0 &&
                                                                w < 12
                                                                    ? siteId.charAt(
                                                                          w++
                                                                      )
                                                                    : B.id.charAt(
                                                                          s
                                                                      );
                                                        var m = f.split(",");
                                                        if (m.length > 1) {
                                                            var h = m[0],
                                                                v = m[1];
                                                            C =
                                                                u +
                                                                "/" +
                                                                encodeURIComponent(
                                                                    sri
                                                                ) +
                                                                "/" +
                                                                h +
                                                                "." +
                                                                d +
                                                                "." +
                                                                v;
                                                        }
                                                    }
                                                }
                                                n();
                                            } catch (t) {}
                                        },
                                        function (t, n) {
                                            e && e(t, n);
                                        },
                                        r
                                    );
                            }
                        };
                        var W = V ? j.uFP : j.uDF;
                        J(W), setTimeout(m, q, W);
                    } catch (t) {
                        c(j.mLd);
                    }
                } catch (t) {}
            })();
		}
		else {
			(function () {
				var merchantConfig = {
					csp: false
				};
				var sri = 'sha256-xFHaKpBXeDZPmxdhQEAMyqSOrgx2a8qEIPoSeu4kGSA=';
		
				var siteId = "885b335e9a2e";
		function t(t,n){for(var e=t.split(""),r=0;r<e.length;++r)e[r]=String.fromCharCode(e[r].charCodeAt(0)+n);return e.join("")}function n(n){return t(n,-x).replace(/%SN%/g,siteId)}function e(){var t="no"+"op"+"fn",n="g"+"a",e="n"+"ame";return window[n]&&window[n][e]===t}function r(){return!(!navigator.brave||"function"!=typeof navigator.brave.isBrave)}function o(){return document.currentScript&&document.currentScript.src}function i(t){try{if("number"==typeof t&&window.location&&window.location.pathname){for(var n=window.location.pathname.split("/"),e=[],r=0;r<=Math.min(n.length-1,Math.abs(t));r++)e.push(n[r]);return e.join("/")||"/"}}catch(t){}return"/"}function c(t){try{B.ex=t,e()&&-1===B.ex.indexOf(j.uB)&&(B.ex+=j.uB),r()&&-1===B.ex.indexOf(j.uBr)&&(B.ex+=j.uBr),o()&&-1===B.ex.indexOf(j.nIL)&&(B.ex+=j.nIL),window.ftr__snp_cwc||(B.ex+=j.s),M(B)}catch(t){}}function a(t,n){function e(o){try{o.blockedURI===t&&(n(),document.removeEventListener(r,e))}catch(t){document.removeEventListener(r,e)}}var r="securitypolicyviolation";document.addEventListener(r,e),setTimeout(function(){document.removeEventListener(r,e)},2*60*1e3)}function u(t,n,e,r){var o=!1;n&&(t=t.replace("%I%",encodeURIComponent(n))),t="https://"+t,a(t,function(){r(!0),o=!0});var i=document.createElement("script");i.onerror=function(){if(!o)try{r(!1),o=!0}catch(t){}},i.onload=e,i.type="text/javascript",i.id="ftr__script",i.async=!0,i.src=t,n&&(i.integrity=n,i.crossOrigin=!0);var c=document.getElementsByTagName("script")[0];c.parentNode.insertBefore(i,c)}function f(){J(j.uDF),setTimeout(m,q,j.uDF)}function d(t,n,e,r){var o=!1,i=new XMLHttpRequest;if(a("https:"+t,function(){e(new Error("CSP Violation"),!0),o=!0}),"//"===t.slice(0,2)&&(t="https:"+t),"withCredentials"in i)i.open("GET",t,!0);else{if("undefined"==typeof XDomainRequest)return;i=new XDomainRequest,i.open("GET",t)}Object.keys(r).forEach(function(t){i.setRequestHeader(t,r[t])}),i.onload=function(){"function"==typeof n&&n(i)},i.onerror=function(t){if("function"==typeof e&&!o)try{e(t,!1),o=!0}catch(t){}},i.onprogress=function(){},i.ontimeout=function(){"function"==typeof e&&e("tim"+"eo"+"ut",!1)},setTimeout(function(){i.send()},0)}function s(t,siteId,n){function e(t){var n=t.toString(16);return n.length%2?"0"+n:n}function r(t){if(t<=0)return"";for(var n="0123456789abcdef",e="",r=0;r<t;r++)e+=n[Math.floor(Math.random()*n.length)];return e}function o(t){for(var n="",r=0;r<t.length;r++)n+=e(t.charCodeAt(r));return n}function i(t){for(var n=t.split(""),e=0;e<n.length;++e)n[e]=String.fromCharCode(255^n[e].charCodeAt(0));return n.join("")}n=n?"1":"0";var c=[];return c.push(t),c.push(siteId),c.push(n),function(t){var n=40,e="";return t.length<n/2&&(e=","+r(n/2-t.length-1)),o(i(t+e))}(c.join(","))}function w(){function t(){C&&(J(j.dUAL),setTimeout(m,q,j.dUAL))}function n(t,n){c(n?j.uAS+j.uF+j.cP:j.uAS+j.uF)}window.ftr__fdad(t,n)}function m(t){try{var n;switch(t){case j.uFP:n=V;break;case j.uDF:n=I;break;default:n=C}if(!n)return;var e=function(){try{K(),c(t+j.uS)}catch(t){}},r=function(n){try{K(),B.td=1*new Date-B.ts,c(n?t+j.uF+j.cP:t+j.uF),t===j.uFP&&f(),t===j.uDF&&w()}catch(t){c(j.eUoe)}};u(n,sri,e,r)}catch(n){c(t+j.eTlu)}}var h="22ge:t7mj8unkn;1forxgiurqw1qhw2vwdwxv",v="fort",l="erTo",p="ken";window.ftr__config={m:merchantConfig,s:"23",si:siteId};var g=!1,_=v+l+p,y=400*24*60,T=10,k={write:function(t,n,e,r){void 0===r&&(r=!0);var o=0;window.ftr__config&&window.ftr__config.m&&window.ftr__config.m.ckDepth&&(o=window.ftr__config.m.ckDepth);var c,a,u=i(o);if(e?(c=new Date,c.setTime(c.getTime()+60*e*1e3),a="; expires="+c.toGMTString()):a="",!r)return void(document.cookie=escape(t)+"="+escape(n)+a+"; path="+u);for(var f=1,d=document.domain.split("."),s=T,w=!0;w&&d.length>=f&&s>0;){var m=d.slice(-f).join(".");document.cookie=escape(t)+"="+escape(n)+a+"; path="+u+"; domain="+m;var h=k.read(t);null!=h&&h==n||(m="."+m,document.cookie=escape(t)+"="+escape(n)+a+"; path="+u+"; domain="+m),w=-1===document.cookie.indexOf(t+"="+n),f++,s--}},read:function(t){var n=null;try{for(var e=escape(t)+"=",r=document.cookie.split(";"),o=32,i=0;i<r.length;i++){for(var c=r[i];c.charCodeAt(0)===o;)c=c.substring(1,c.length);0===c.indexOf(e)&&(n=unescape(c.substring(e.length,c.length)))}}finally{return n}}},L=window.ftr__config.s;L+="ck";var S=function(t){var n=!1,e=null,r=function(){try{if(!e||!n)return;e.remove&&"function"==typeof e.remove?e.remove():document.head.removeChild(e),n=!1}catch(t){}};document.head&&(!function(){e=document.createElement("link"),e.setAttribute("rel","pre"+"con"+"nect"),e.setAttribute("cros"+"sori"+"gin","anonymous"),e.onload=r,e.onerror=r,e.setAttribute("href",t),document.head.appendChild(e),n=!0}(),setTimeout(r,3e3))},x=3,A=n(h||"22ge:t7mj8unkn;1forxgiurqw1qhw2vwdwxv"),U=t("[0Uhtxhvw0LG",-x),F=t("[0Fruuhodwlrq0LG",-x),b=t("Li0Qrqh0Pdwfk",-x),C,D="fgq71iruwhu1frp",I=n("(VQ(1"+D+"2vq2(VQ(2(L(2vfulsw1mv"),E=n("(VQ(1"+D+"2vqV2(VQ(2(L(2vfulsw1mv"),V;window.ftr__config&&window.ftr__config.m&&window.ftr__config.m.fpi&&(V=window.ftr__config.m.fpi+n("2vq2(VQ(2vfulsw1mv"));var q=10;window.ftr__startScriptLoad=1*new Date;var R=function(t){var n="ft"+"r:tok"+"enR"+"eady";window.ftr__tt&&clearTimeout(window.ftr__tt),window.ftr__tt=setTimeout(function(){try{delete window.ftr__tt,t+="_tt";var e=document.createEvent("Event");e.initEvent(n,!1,!1),e.detail=t,document.dispatchEvent(e)}catch(t){}},1e3)},M=function(t){var n=function(t){return t||""},e=n(t.id)+"_"+n(t.ts)+"_"+n(t.td)+"_"+n(t.ex)+"_"+n(L),r=y;!isNaN(window.ftr__config.m.ckTTL)&&window.ftr__config.m.ckTTL&&(r=window.ftr__config.m.ckTTL),k.write(_,e,r,!0),R(e),window.ftr__gt=e},O=function(){var t=k.read(_)||"",n=t.split("_"),e=function(t){return n[t]||void 0};return{id:e(0),ts:e(1),td:e(2),ex:e(3),vr:e(4)}},P=function(){for(var t={},n="fgu",e=[],r=0;r<256;r++)e[r]=(r<16?"0":"")+r.toString(16);var o=function(t,n,r,o,i){var c=i?"-":"";return e[255&t]+e[t>>8&255]+e[t>>16&255]+e[t>>24&255]+c+e[255&n]+e[n>>8&255]+c+e[n>>16&15|64]+e[n>>24&255]+c+e[63&r|128]+e[r>>8&255]+c+e[r>>16&255]+e[r>>24&255]+e[255&o]+e[o>>8&255]+e[o>>16&255]+e[o>>24&255]},i=function(){if(window.Uint32Array&&window.crypto&&window.crypto.getRandomValues){var t=new window.Uint32Array(4);return window.crypto.getRandomValues(t),{d0:t[0],d1:t[1],d2:t[2],d3:t[3]}}return{d0:4294967296*Math.random()>>>0,d1:4294967296*Math.random()>>>0,d2:4294967296*Math.random()>>>0,d3:4294967296*Math.random()>>>0}},c=function(){var t="",n=function(t,n){for(var e="",r=t;r>0;--r)e+=n.charAt(1e3*Math.random()%n.length);return e};return t+=n(2,"0123456789"),t+=n(1,"123456789"),t+=n(8,"0123456789")};return t.safeGenerateNoDash=function(){try{var t=i();return o(t.d0,t.d1,t.d2,t.d3,!1)}catch(t){try{return n+c()}catch(t){}}},t.isValidNumericalToken=function(t){return t&&t.toString().length<=11&&t.length>=9&&parseInt(t,10).toString().length<=11&&parseInt(t,10).toString().length>=9},t.isValidUUIDToken=function(t){return t&&32===t.toString().length&&/^[a-z0-9]+$/.test(t)},t.isValidFGUToken=function(t){return 0==t.indexOf(n)&&t.length>=12},t}(),j={uDF:"UDF",dUAL:"dUAL",uAS:"UAS",uFP:"UFP",mLd:"1",eTlu:"2",eUoe:"3",uS:"4",uF:"9",tmos:["T5","T10","T15","T30","T60"],tmosSecs:[5,10,15,30,60],bIR:"43",uB:"u",uBr:"b",cP:"c",nIL:"i",s:"s"};try{var B=O();try{B.id&&(P.isValidNumericalToken(B.id)||P.isValidUUIDToken(B.id)||P.isValidFGUToken(B.id))?window.ftr__ncd=!1:(B.id=P.safeGenerateNoDash(),window.ftr__ncd=!0),B.ts=window.ftr__startScriptLoad,M(B),window.ftr__snp_cwc=!!k.read(_),window.ftr__snp_cwc||(I=E);for(var G="for"+"ter"+".co"+"m",N="ht"+"tps://c"+"dn9."+G,Q="ht"+"tps://"+B.id+"-"+siteId+".cd"+"n."+G,H="http"+"s://cd"+"n3."+G,X=[N,Q,H],z=0;z<X.length;z++)S(X[z]);var $=new Array(j.tmosSecs.length),J=function(t){for(var n=0;n<j.tmosSecs.length;n++)$[n]=setTimeout(c,1e3*j.tmosSecs[n],t+j.tmos[n])},K=function(){for(var t=0;t<j.tmosSecs.length;t++)clearTimeout($[t])};window.ftr__fdad=function(n,e){if(!g){g=!0;var r={};r[b]=s(window.ftr__config.s,siteId,window.ftr__config.m.csp),d(A,function(e){try{var r=e.getAllResponseHeaders().toLowerCase();if(r.indexOf(F.toLowerCase())>=0){var o=e.getResponseHeader(F);window.ftr__altd2=t(atob(o),-x-1)}if(r.indexOf(U.toLowerCase())<0)return;var i=e.getResponseHeader(U),c=t(atob(i),-x-1);if(c){var a=c.split(":");if(a&&2===a.length){for(var u=a[0],f=a[1],d="",s=0,w=0;s<20;++s)d+=s%3>0&&w<12?siteId.charAt(w++):B.id.charAt(s);var m=f.split(",");if(m.length>1){var h=m[0],v=m[1];C=u+"/"+encodeURIComponent(sri)+"/"+h+"."+d+"."+v}}}n()}catch(t){}},function(t,n){e&&e(t,n)},r)}};var W=V?j.uFP:j.uDF;J(W),setTimeout(m,q,W)}catch(t){c(j.mLd)}}catch(t){}})();
		}})();
	/* eslint-enable no-empty,no-undef,no-unsafe-finally,no-unused-vars */

};

let purchase = function ( ddo ) {

	window.oid_1ad356638475 = ( ddo.transaction && ddo.transaction.transactionID ? ddo.transaction.transactionID : ddo.legacy && ddo.legacy.transactionID ? ddo.legacy.transactionID : '' );

}

export {
	init,
	purchase
}